(() => {
  document.addEventListener('click', event => {
    if (!event.target.closest('.grc-product-summary')) return;
    const panel = document.querySelector('.grc-product-reviews')?.closest('accordion-disclosure');
    if (!panel) return;
    if (typeof panel.open === 'function') {
      panel.open({ instant: true });
    } else {
      const details = panel.querySelector('details');
      if (details) {
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
      }
    }
  }, true);
})();
